"use strict";
// Copyright 2019 Centrality Investments Limited
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const polkadot_1 = require("@cennznet/types/polkadot");
const drr_1 = require("@plugnet/api-derive/util/drr");
const operators_1 = require("rxjs/operators");
const EnhancedAssetId_1 = __importDefault(require("../registry/EnhancedAssetId"));
const utils_1 = require("../utils/utils");
const PREFIX = 'GenericAsset ReservedBalance';
function reservedBalance(api) {
    return (assetId, address) => {
        const key = utils_1.generateStorageDoubleMapKey(PREFIX, new EnhancedAssetId_1.default(assetId), new polkadot_1.Address(address));
        return api.rpc.state.subscribeStorage([key]).pipe(operators_1.map(([data]) => {
            return new polkadot_1.Balance(data.unwrapOr(undefined));
        }), drr_1.drr());
    };
}
exports.reservedBalance = reservedBalance;
function reservedBalanceAt(api) {
    return (hash, assetId, address) => {
        const key = utils_1.generateStorageDoubleMapKey(PREFIX, new EnhancedAssetId_1.default(assetId), new polkadot_1.Address(address));
        return api.rpc.state.getStorage(key, hash).pipe(operators_1.map((data) => {
            return new polkadot_1.Balance(data.unwrapOr(undefined));
        }), drr_1.drr());
    };
}
exports.reservedBalanceAt = reservedBalanceAt;
//# sourceMappingURL=reservedBalance.js.map